export default defineAppConfig({
  ui: {
    accordion: {
      default: {
        openIcon: 'i-mdi-chevron-down',
      },
    },
    button: {
      default: {
        color: 'black',
        loadingIcon: 'i-mdi-loading',
        size: 'md',
      },
      rounded: 'rounded-full',
    },
    footer: {
      bottom: {
        wrapper: 'border-t border-gray-200 dark:border-gray-800',
      },
      top: {
        container: 'py-8 lg:py-16',
        wrapper: 'border-t border-gray-200 dark:border-gray-800',
      },
    },
    gray: 'zinc',
    header: {
      links: {
        active: 'text-gray-900 dark:text-white after:opacity-100',
        base: 'py-2 px-4 font-medium transition-colors relative after:absolute after:-bottom-px after:inset-x-2 after:h-px after:rounded-full after:opacity-0 after:bg-gray-900 dark:after:bg-white after:transition-opacity',
        inactive: 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200',
        wrapper: 'ring-1 ring-gray-200 dark:ring-gray-800 px-3 gap-x-0 rounded-full',
      },
      wrapper: 'lg:!border-transparent bg-gray-50 dark:bg-gray-950',
    },
    icons: {
      chevron: 'i-mdi-chevron-down',
      close: 'i-mdi-close',
      menu: 'i-mdi-menu',
    },
    input: {
      rounded: 'rounded-full',
    },
    pricing: {
      card: {
        features: {
          item: {
            icon: {
              base: 'text-gray-900 dark:text-white',
            },
          },
        },
        highlight: 'ring-gray-900 dark:ring-white',
      },
    },
    primary: 'rose',
    variables: {
      dark: {
        background: 'var(--color-gray-950)',
      },
      light: {
        background: 'var(--color-gray-50)',
      },
    },
  },
})
